import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const ViewIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 14 14"
    sx={{ width: '14px', height: '14px', color: 'gray', ...sx }}
    {...props}
  >
    <path
      d="M6.9987 2.625C4.08203 2.625 1.5912 4.43917 0.582031 7C1.5912 9.56083 4.08203 11.375 6.9987 11.375C9.91536 11.375 12.4062 9.56083 13.4154 7C12.4062 4.43917 9.91536 2.625 6.9987 2.625ZM6.9987 9.91667C5.3887 9.91667 4.08203 8.61 4.08203 7C4.08203 5.39 5.3887 4.08333 6.9987 4.08333C8.6087 4.08333 9.91536 5.39 9.91536 7C9.91536 8.61 8.6087 9.91667 6.9987 9.91667ZM6.9987 5.25C6.03036 5.25 5.2487 6.03167 5.2487 7C5.2487 7.96833 6.03036 8.75 6.9987 8.75C7.96703 8.75 8.7487 7.96833 8.7487 7C8.7487 6.03167 7.96703 5.25 6.9987 5.25Z"
      fill="inherit"
    />
  </SvgIcon>
)

ViewIcon.defaultProps = {
  sx: null,
}
